import z from "zod";

export const ChatInputSchema = z
  .object({
    message: z
      .string({ message: "メッセージを入力してください" })
      .trim()
      .max(2000, "メッセージは2000文字以内で入力してください")
      .optional(), // Bỏ .min(1) để cho phép empty
    files: z
      .array(
        z.object({
          file: z.instanceof(File),
        })
      )
      .optional(), // array of { file: File}
  })
  .refine(
    (data) => {
      // Pass khi có message hoặc có file
      const hasMessage = data.message && data.message.trim().length > 0;
      const hasFiles = data.files && data.files.length > 0;
      return hasMessage || hasFiles;
    },
    {
      message: "メッセージまたはファイルのいずれかを入力してください",
      path: ["message"], // Hiển thị lỗi ở field message
    }
  );

export type ChatInputType = z.infer<typeof ChatInputSchema>;
